import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {InventoryService} from "../../../service/inventory.service";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class inventoryDetailResolver implements Resolve<any> {

  constructor(private inventoryService: InventoryService) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const id = route.paramMap.get('id');
    return this.inventoryService.getInventoryByIdV2(id!);
  }
}
